import StudyListPagination from './StudyListPagination';

export default StudyListPagination;
